




































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as notificationService from "@/services/notification/index";
import * as changePasswordApi from "@/services/user/index";

@Component({
  name: "ChangePasswordForm",
})
export default class ChangePasswordForm extends Vue {
  @Prop(String) private token!: string;

  private password: string = "";
  private confirmPassword: string = "";
  private isLoading: boolean | null = null;
  private passwordLength: boolean | null = null;
  private passwordMacth: boolean | null = null;
  private response: string | undefined = undefined;
  private success: boolean = false;

  private hasMinMaxLength() {
    if (this.password.length >= 8) {
      this.passwordLength = false;
      return;
    }
    this.passwordLength = true;
    return;
  }

  private matchPasswords() {
    if (this.confirmPassword === this.password) {
      this.passwordMacth = false;
      return;
    }
    this.passwordMacth = true;
    return;
  }

  private async save() {
    this.isLoading = true;
    const token = this.token;
    const password = this.password;
    try {
      this.response = await changePasswordApi.savePassword({ password, token });
      this.success = true;
      setTimeout(() => {
        this.$router.push({name: "login"});
      }, 10000);
    } catch (e) {
    } finally {
      this.isLoading = false;
    }
  }
}
